import createNotificationModel, { prop } from 'models/notification/lib/create_notification_model';
import IdGenerator from 'scripts/domain/contracts/id_generator';
import NotificationType from 'models/notification/notification_type';

export default createNotificationModel(NotificationType.DISCONNECT, {
  modelName: 'DisconnectNotification',
  properties: {
    id: prop(String).isRequired,
    reason: String,
  },
  statics: {
    create(attrs) {
      return new this({ id: IdGenerator.newId(), ...attrs });
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/notification/disconnect_notification.js